import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { DirectiveModule, FinFormsModule, PipesModule } from '@fcom/common';
import { FcomFormsModule, LoaderModule } from '@fcom/ui-components';
import { UiTranslateModule } from '@fcom/ui-translate';
import { UiComponentsModule } from '@fcom/ui-components/ui-components.module';
import { ComponentsModule } from '@fcom/common/components/components.module';
import { RefundsCommonModule } from '@fcom/refunds-common';
import { RefundsService } from '@fcom/refunds-common/services/refunds.service';
import { CommonBookingAncillaryService } from '@fcom/common-booking/modules/ancillaries/services/common-booking-ancillary.service';

import { MmbRefundFormComponent } from './mmb-refund-form/mmb-refund-form.component';

@NgModule({
  declarations: [MmbRefundFormComponent],
  exports: [MmbRefundFormComponent],
  imports: [
    CommonModule,
    DirectiveModule,
    PipesModule,
    UiTranslateModule,
    UiComponentsModule,
    ComponentsModule,
    FcomFormsModule,
    FinFormsModule,
    RefundsCommonModule,
    LoaderModule,
    RouterModule,
  ],
  providers: [RefundsService, CommonBookingAncillaryService],
})
export class MmbRefundWidgetModule {}
